/** The card a configuration section sits in. */
export const CONFIGURATION_CARD_CLASS =
    'border-divider bg-paper overflow-hidden rounded-[7px] border new:border-0 new:shadow-card new:outline-hidden';

/** The grey caption band across the top of a configuration card. */
export const CONFIGURATION_CARD_HEADER_CLASS =
    'border-divider bg-grey-50 text-caption flex min-h-[38px] items-center border-b px-4 py-2 font-medium';

/** The band across a settings card that titles a group of its rows. */
export const SETTING_GROUP_BAND_CLASS =
    'bg-grey-50 text-fg new:bg-surface-subtle new:text-grey-600 new:font-semibold new:tracking-[0.06em] new:uppercase px-5 py-2.5 text-xs leading-[18px] font-medium';
